import { hotelConstants } from '../constants/hotelConstants';

const initialState = {
    loading : false,
    data: null, 
    sections: {},
    roomCategories : null,
    meetingRooms : null,
    facilities : null,
    restaurants : null,
    bookableItems: null,
    error : null
};

const requestsReducer = (state = initialState, action) => {
    switch (action.type) {
        case hotelConstants.DATA_SUCCESS :
            return {
                ...state,
                loading : false,
                data : action.data,
                sections : action.sections
            }
        case hotelConstants.ROOM_CATEGORIES_SUCCESS :
            return {
                ...state,
                roomCategories : action.items
            }
        case hotelConstants.MEETING_ROOMS_SUCCESS :
            return {
                ...state,
                meetingRooms : action.items
            }
        case hotelConstants.FACILITIES_SUCCESS :
            return {
                ...state,
                facilities : action.items
            }
        case hotelConstants.RESTAURANTS_SUCCESS :
            return {
                ...state,
                restaurants : action.items
            }
        case hotelConstants.BOOKABLE_ITEMS_SUCCESS :
            return {
                ...state,
                bookableItems : action.items
            }
        case hotelConstants.FORCE_THEME : 
            return {
                ...state,
                data : { ...state.data, settings : { ...state.data.settings, theme : action.theme } }
            }
        case hotelConstants.NOTIFICATION : 
            if (state.data.id == action.data.id) {
                return {
                    ...state,
                    data : { ...state.data, ...action.data },
                    sections : { ...state.sections, ...action.sections }
                }
            }
            console.log('notif id', action.data.id)
        default:
            return state
    }
}

export default requestsReducer